import { render, staticRenderFns } from "./preview-drawing-card.component.vue?vue&type=template&id=dfd9b9c8&"
import script from "./preview-drawing-card.component.ts?vue&type=script&lang=ts&"
export * from "./preview-drawing-card.component.ts?vue&type=script&lang=ts&"
import style0 from "./preview-drawing-card.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
